

export const parseColor = (color, def = 'x') => {

  if (color){
    return color.content
  }else{
    return def
  }
}